import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@src/utils/baseQuery";

export interface GetResourcePayload {
  parentId: string;
  type: string;
  downloadToken?: string;
}

export const SubjectDownloadApiSlice = createApi({
  reducerPath: "SubjectDownloadApiSlice",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getDownloadToken: builder.query<
      { downloadToken: string },
      { parentId?: string; type?: string }
    >({
      query: ({ parentId, type }) => ({
        url: `text-files/download-token?parentId=${parentId}&type=${type}`,
        method: "GET",
      }),
    }),
    getResourceForParentWithToken: builder.query<Blob, GetResourcePayload>({
      query: ({ parentId, type = "tutorial", downloadToken }) => {
        let url = `text-files/download?parentId=${parentId}&type=${type}`;
        if (downloadToken) {
          url += `&downloadToken=${downloadToken}`;
        }
        return {
          url,
          method: "GET",
          responseHandler: async (response) => {
            const blob = await response.blob();
            return blob;
          },
        };
      },
    }),
  }),
});

export const {
  useLazyGetDownloadTokenQuery,
  useLazyGetResourceForParentWithTokenQuery,
  useGetResourceForParentWithTokenQuery,
} = SubjectDownloadApiSlice;
